import { defineAction } from '~/prix'
import searchAddressAction from './geoSearchAddress.action.json'
import { z } from 'zod'

const searchAddressDefinition = defineAction({
  ...searchAddressAction,
  input: z.object({
    address: z.string().describe('Endereço parcial a ser geocodificado.'),
    include: z
      .array(z.string())
      .describe('Campos adicionais a serem incluídos na resposta.')
      .optional(),
    limit: z
      .number()
      .min(1)
      .max(15)
      .describe('Número máximo de resultados a serem retornados.')
      .optional(),
    number: z.string().describe('Número do endereço a ser geocodificado.').optional(),
    municipalityId: z
      .number()
      .describe('ID do município para restringir a busca (usado no where do service).')
      .optional(),
    similarityCutoff: z
      .number()
      .min(0)
      .max(1)
      .describe('Corte mínimo de similaridade (0 a 1).')
      .optional(),
  }),
  output: z.object({
    results: z.array(z.any({})).describe('Resultados da geocodificação.').nullish(),
    items: z.array(z.object({})).describe('Resultados da geocodificação.').nullish(),
  }),
})

export default searchAddressDefinition
